import { create } from 'zustand';

/**
 * ProjectFormに渡すための型
 */
export type ProjectUploadExtractionResponse = {
  project_description: string;
};

type PdfExtractionState = {
  /** PDF解析結果 */
  extractionResult: ProjectUploadExtractionResponse | null;
  /** 解析結果を設定 */
  setExtractionResult: (result: ProjectUploadExtractionResponse | null) => void;
};

/**
 * PDF解析結果を管理するZustandストア
 *
 * PDFアップロード後の解析結果を保持し、
 * 他のコンポーネントから参照可能にする
 */
export const usePdfExtractionStore = create<PdfExtractionState>((set) => ({
  extractionResult: null,
  setExtractionResult: (result) => set({ extractionResult: result }),
}));
